import { render } from "./DecadeComponent.vue?vue&type=template&id=0cfdeb35&scoped=true"
import script from "./DecadeComponent.vue?vue&type=script&lang=js"
export * from "./DecadeComponent.vue?vue&type=script&lang=js"

import "./DecadeComponent.vue?vue&type=style&index=0&id=0cfdeb35&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cfdeb35"]])

export default __exports__